module.exports = __webpack_public_path__ + "staticcomp/img/share.726ad73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/share.jpg
// module id = xp+r
// module chunks = 39